<div class="grid">
    <!-- Risk Assessment Matrix Section -->
    <div class="col-12" style="overflow-x: auto;">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2 px-4 py-2">
                    <i class="pi pi-chart-bar text-2xl mr-2"></i>
                    <h2 class="m-0">Matrice d'évaluation des risques</h2>
                </div>
            </ng-template>

            <div class="grid">
                <!-- Legend -->
                <div class="col-12 mb-3">
                    <h3 class="mb-3">Légende des niveaux</h3>
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-3 mb-2">
                            <div class="flex align-items-center gap-2">
                                <div class="w-2rem h-2rem" style="background-color: #4caf50;"></div>
                                <span>Risque faible – 1 à 3</span>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-3 mb-2">
                            <div class="flex align-items-center gap-2">
                                <div class="w-2rem h-2rem" style="background-color: #ffeb3b;"></div>
                                <span>Risque modéré – 4 à 6</span>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-3 mb-2">
                            <div class="flex align-items-center gap-2">
                                <div class="w-2rem h-2rem" style="background-color: #ff9800;"></div>
                                <span>Risque élevé – 7 à 10</span>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-3 mb-2">
                            <div class="flex align-items-center gap-2">
                                <div class="w-2rem h-2rem" style="background-color: #f44336;"></div>
                                <span>Risque critique – 11 à 25</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Matrix Table -->
                <div class="col-12 flex flex-column justify-content-center">
                    <div class="overflow-x-auto">
                        <table class="w-full border-collapse" style="border: 1px solid #dee2e6;">
                            <thead>
                                <tr style="background-color: #f8f9fa;">
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 120px;">
                                        <div>Gravité</div>
                                        <div>→</div>
                                        <div style="margin-top: 1rem;">Probabilité ↓</div>
                                    </th>
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 100px;">
                                        <div class="mb-1">1</div>
                                        <div class="font-normal">Très faible</div>
                                    </th>
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 100px;">
                                        <div class="mb-1">2</div>
                                        <div class="font-normal">Faible</div>
                                    </th>
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 100px;">
                                        <div class="mb-1">3</div>
                                        <div class="font-normal">Modérée</div>
                                    </th>
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 100px;">
                                        <div class="mb-1">4</div>
                                        <div class="font-normal">Élevée</div>
                                    </th>
                                    <th class="p-2 text-center font-bold" style="border: 1px solid #dee2e6; min-width: 100px;">
                                        <div class="mb-1">5</div>
                                        <div class="font-normal">Très élevée</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Row 1: Très improbable -->
                                <tr>
                                    <td class="p-2 font-bold" style="border: 1px solid #dee2e6; background-color: #f8f9fa;">
                                        <div>1</div>
                                        <div class="font-normal">Très improbable</div>
                                    </td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #4caf50;">1</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #4caf50;">2</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">3</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">4</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">5</td>
                                </tr>
                                <!-- Row 2: Improbable -->
                                <tr>
                                    <td class="p-2 font-bold" style="border: 1px solid #dee2e6; background-color: #f8f9fa;">
                                        <div>2</div>
                                        <div class="font-normal">Improbable</div>
                                    </td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #4caf50;">2</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">4</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">6</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ff9800;">8</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ff9800;">10</td>
                                </tr>
                                <!-- Row 3: Possible -->
                                <tr>
                                    <td class="p-2 font-bold" style="border: 1px solid #dee2e6; background-color: #f8f9fa;">
                                        <div>3</div>
                                        <div class="font-normal">Possible</div>
                                    </td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">3</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">6</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ff9800;">9</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">12</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">15</td>
                                </tr>
                                <!-- Row 4: Probable -->
                                <tr>
                                    <td class="p-2 font-bold" style="border: 1px solid #dee2e6; background-color: #f8f9fa;">
                                        <div>4</div>
                                        <div class="font-normal">Probable</div>
                                    </td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">4</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ff9800;">8</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">12</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">16</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">20</td>
                                </tr>
                                <!-- Row 5: Très probable -->
                                <tr>
                                    <td class="p-2 font-bold" style="border: 1px solid #dee2e6; background-color: #f8f9fa;">
                                        <div>5</div>
                                        <div class="font-normal">Très probable</div>
                                    </td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ffeb3b;">5</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #ff9800;">10</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">15</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">20</td>
                                    <td class="p-3 text-center font-bold text-xl" style="border: 1px solid #dee2e6; background-color: #f44336;">25</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Definitions -->
                <div class="col-12">
                    <h3>Définitions</h3>
                    <p-accordion>
                        <p-accordionTab header="Gravité">
                            <ul class="list-none p-0 m-0">
                                <li class="mb-3">
                                    <span class="font-bold">Très élevée: </span>
                                    <span>Risque de lésion avec limitation permanentes ou atteinte permanente ou risque de décès du travailleur</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Élevée: </span>
                                    <span>Risque de blessure grave avec limitation temporaires ou permanentes (Déchirure, brûlure importante, fracture complexe)</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Modérée: </span>
                                    <span>Risque de blessure avec limitation temporaires ou arrêt de travail temporaire (Fracture, entorse, écrasement, brûlure)</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Faible: </span>
                                    <span>Risque de blessure légère nécessitant des premiers soins, sans arrêt de travail (Corps étranger dans l'œil, lacération légère)</span>
                                </li>
                                <li>
                                    <span class="font-bold">Très faible: </span>
                                    <span>Risque de blessure mineure sans arrêt de travail (ecchymose, éraflure, douleur légère et non persistante)</span>
                                </li>
                            </ul>
                        </p-accordionTab>
                        <p-accordionTab header="Probabilité">
                            <ul class="list-none p-0 m-0">
                                <li class="mb-3">
                                    <span class="font-bold">Très probable: </span>
                                    <span>L'évènement est attendu et il va très certainement ce produire.</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Probable: </span>
                                    <span>L'événement est très susceptible de se produire, des situations similaires ont déjà causé ce risque.</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Possible: </span>
                                    <span>L'évènement peut survenir dans certaines circonstances</span>
                                </li>
                                <li class="mb-3">
                                    <span class="font-bold">Improbable: </span>
                                    <span>Ça peut arriver, mais c'est peu probable</span>
                                </li>
                                <li>
                                    <span class="font-bold">Très improbable: </span>
                                    <span>Évènement exceptionnel, aucun antécédent connu.</span>
                                </li>
                            </ul>
                        </p-accordionTab>
                    </p-accordion>
                </div>
            </div>
        </p-card>
    </div>

    <div class="col-12">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2 px-4 py-2">
                    <i class="pi pi-exclamation-triangle text-2xl mr-2"></i>
                    <h2 class="m-0">Danger critique Hamel Construction</h2>
                </div>
            </ng-template>
            <div class="grid">
                <div class="col-12 flex justify-content-center">
                    <img src="images/Dangers_Hamel_(1).jpg" alt="Danger critique Hamel Construction" class="w-full h-full object-fit-contain" style="max-width: 50rem;">
                </div>
                <div class="col-12 flex justify-content-center">
                    <img src="images/Dangers_Hamel_(2).jpg" alt="Danger critique Hamel Construction" class="w-full h-full object-fit-contain" style="max-width: 50rem;">
                </div>
                <div class="col-12 flex justify-content-center">
                    <img src="images/Dangers_Hamel_(3).jpg" alt="Danger critique Hamel Construction" class="w-full h-full object-fit-contain" style="max-width: 50rem;">
                </div>
            </div>
        </p-card>
    </div>

    <!-- Zero Tolerance Section -->
    <div class="col-12">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2 px-4 py-2">
                    <i class="pi pi-ban text-2xl mr-2"></i>
                    <h2 class="m-0">Tolérance Zéro</h2>
                </div>
            </ng-template>

            <div class="mb-4">
                <p class="text-lg">IMPORTANT: Une tolérance zéro de la CNESST comporte que le total sera le maximum c'est-à-dire 5 pour la gravité et 5 pour la probabilité</p>
            </div>

            <div class="grid">
                <div class="col-12">
                    <p class="line-height-3">
                        La CNESST a, depuis plusieurs années, développé des plans d'actions avec des cibles de tolérance zéro pour des secteurs d'activés spécifiques, dans le but de mobiliser les efforts de tous pour éliminer les dangers et réduire le nombre d'accidents.
                    </p>
                    <p class="line-height-3">
                        La CNESST poursuit son engagement à l'égard des cibles de tolérance zéro sur les dangers à conséquence grave identifiés paritairement. Les tolérances zéro sont donc maintenues... mais élargies à tous les milieux de travail.
                    </p>
                </div>

                <div class="col-12">
                    <h3>Situations de tolérance zéro</h3>
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-bolt text-4xl mb-3"></i>
                                    <h4 class="mb-1">Électricité</h4>
                                    <p class="text-sm m-0">Danger d'électrisation</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-building text-4xl mb-3"></i>
                                    <h4 class="mb-1">Effondrement</h4>
                                    <p class="text-sm m-0">Danger d'effondrement d'un échafaudage</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-exclamation-circle text-4xl mb-3"></i>
                                    <h4 class="mb-1">Monoxyde de carbone</h4>
                                    <p class="text-sm m-0">Danger de l'exposition</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-cloud text-4xl mb-3"></i>
                                    <h4 class="mb-1">Amiante</h4>
                                    <p class="text-sm m-0">Danger de l'exposition aux poussières d'amiante</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-circle-fill text-4xl mb-3"></i>
                                    <h4 class="mb-1">Silice cristalline</h4>
                                    <p class="text-sm m-0">Danger de l'exposition aux poussières de silice</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-arrow-down text-4xl mb-3"></i>
                                    <h4 class="mb-1">Chute de hauteur</h4>
                                    <p class="text-sm m-0">Danger de chute de hauteur de plus de 3 mètres</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-stop-circle text-4xl mb-3"></i>
                                    <h4 class="mb-1">Roches instables</h4>
                                    <p class="text-sm m-0">Danger d'être frappé par une roche instable dans une mine souterraine</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-exclamation-triangle text-4xl mb-3"></i>
                                    <h4 class="mb-1">Effondrement</h4>
                                    <p class="text-sm m-0">Danger d'effondrement des parois d'un creusement non étançonné</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-cog text-4xl mb-3"></i>
                                    <h4 class="mb-1">Sécurité des machines</h4>
                                    <p class="text-sm m-0">exposition aux zones dangereuses d'une machine</p>
                                </div>
                            </p-card>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <p-card styleClass="h-full">
                                <div class="flex flex-column align-items-center text-center">
                                    <i class="pi pi-arrow-up-right text-4xl mb-3"></i>
                                    <h4 class="mb-1">Chute de hauteur</h4>
                                    <p class="text-sm m-0">Danger de chute à partir d'une échelle</p>
                                </div>
                            </p-card>
                        </div>
                    </div>
                </div>
            </div>
        </p-card>
    </div>
</div> 